"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { cn } from "@/lib/utils";
function SeasonDropdownConsumer() {
  const {
    terms,
    loading
  } = useEcommerceTerms();
  if (loading) {
    return <div className="h-9 w-32 rounded-md bg-muted/30 animate-pulse" />;
  }
  return <Select>
      <SelectTrigger className="glass-effect border-border-strong">
        <SelectValue placeholder="Season" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Seasons</SelectItem>
        {terms.map(term => <SelectItem key={term.id} value={term.slug} data-index={term.id}>
            {term.name}
          </SelectItem>)}
      </SelectContent>
    </Select>;
}
function StyleDropdownConsumer() {
  const {
    terms,
    loading
  } = useEcommerceTerms();
  if (loading) {
    return <div className="h-9 w-32 rounded-md bg-muted/30 animate-pulse" />;
  }
  return <Select>
      <SelectTrigger className="glass-effect border-border-strong">
        <SelectValue placeholder="Style" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Styles</SelectItem>
        {terms.map(term => <SelectItem key={term.id} value={term.slug} data-index={term.id}>
            {term.name}
          </SelectItem>)}
      </SelectContent>
    </Select>;
}
function ColorDropdownConsumer() {
  const {
    terms,
    loading
  } = useEcommerceTerms();
  if (loading) {
    return <div className="h-9 w-32 rounded-md bg-muted/30 animate-pulse" />;
  }
  return <Select>
      <SelectTrigger className="glass-effect border-border-strong">
        <SelectValue placeholder="Color" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Colors</SelectItem>
        {terms.map(term => <SelectItem key={term.id} value={term.slug} data-index={term.id}>
            {term.name}
          </SelectItem>)}
      </SelectContent>
    </Select>;
}
export default function GalleryFilters() {
  const [isSticky, setIsSticky] = useState(false);
  return <section id="gallery-filters" className={cn("sticky top-0 z-40 w-full py-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]", isSticky ? "glass-effect shadow-medium" : "bg-background/95 backdrop-blur-sm")} onScroll={() => setIsSticky(window.scrollY > 50)}>
      <div className="container mx-auto px-4">
        <div className="flex items-center gap-4">
          <EcommerceTermsProvider taxonomy="product_tag" wp_term_query={{
          per_page: 20
        }} term_fields={["id", "name", "slug"]}>
            <SeasonDropdownConsumer />
          </EcommerceTermsProvider>

          <EcommerceTermsProvider taxonomy="product_tag" wp_term_query={{
          per_page: 20
        }} term_fields={["id", "name", "slug"]}>
            <StyleDropdownConsumer />
          </EcommerceTermsProvider>

          <EcommerceTermsProvider taxonomy="product_tag" wp_term_query={{
          per_page: 20
        }} term_fields={["id", "name", "slug"]}>
            <ColorDropdownConsumer />
          </EcommerceTermsProvider>
        </div>
      </div>
    </section>;
}